import { types, Image } from "react-bricks/frontend";
import styled from "styled-components";
import TextBlock from "../common/TextBlock";
import { color } from "@styles";

export interface TimelineItemProps {}

export const TimelineItem: types.Brick<TimelineItemProps> = ({}) => {
  return (
    <TimelineItemWrapper>
      <IconWrapper>
        <Image propName="iconSrc" alt={"Timeline icon"} maxWidth={18} aspectRatio={1} />
      </IconWrapper>
      <TextWrapper>
        <TextBlock
          propName="text"
          placeholder="Enter timeline text..."
          renderBlock={({ children }) => <>{children}</>}
        />
      </TextWrapper>
    </TimelineItemWrapper>
  );
};

TimelineItem.schema = {
  name: "timeline-item",
  label: "Timeline Item",
  category: "Timeline Components",
  hideFromAddMenu: true,
  // Define default props
  getDefaultProps: () => ({
    iconSrc: {
      src: "/static/icons/Star.svg",
    },
    text: "Choose your insurance plan",
  }),
  // Define side edit props
  sideEditProps: [],
};

const MOBILE_BREAKPOINT = `@media only screen and (max-width: 53rem)`;

const TimelineItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${MOBILE_BREAKPOINT} {
    flex-direction: row;
    gap: 0.6rem;
  }
`;

const IconWrapper = styled.div`
  width: 2.375rem;
  height: 2.375rem;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${color.P100};
  z-index: 2;
`;

const TextWrapper = styled.div`
  width: 7.2rem;
  text-align: center;
  font-size: 1rem;
  margin-top: 0.5rem;

  ${MOBILE_BREAKPOINT} {
    width: 15rem;
    text-align: left;
  }
`;

export default TimelineItem;
